import { Component, Input, OnInit } from '@angular/core';

import { isSituacaoAtiva, isSituacaoInativa } from '../regiao-situacao';

interface Config {
    isAtiva: boolean;
    isInativa: boolean;
}

@Component({
    selector: 'sgt-regiao-situacao-badge',
    templateUrl: './regiao-situacao-badge.component.html',
    styleUrls: ['./regiao-situacao-badge.component.less']
})
export class RegiaoSituacaoBadgeComponent implements OnInit {
    config: Config;

    /** Situação da região */
    @Input() situacao: number;
    /** Tamanho da font */
    @Input() fontSize = '8px';

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isAtiva: isSituacaoAtiva(this.situacao),
            isInativa: isSituacaoInativa(this.situacao)
        }
    }
}
